import { X, Phone, Video, MoreVertical } from "lucide-react";
import { useAuthStore } from "../store/useAuthStore";
import { useChatStore } from "../store/useChatStore";

const ChatHeader = () => {
  const { selectedUser, setSelectedUser } = useChatStore();
  const { onlineUsers } = useAuthStore();
  if (!selectedUser) return null;

  const isOnline = onlineUsers.includes(selectedUser._id);
  const initialOf = (name = "") => name.trim().charAt(0).toUpperCase() || "?";

  return (
    <div className="px-5 py-3 border-b border-slate-200/60 bg-white/80 backdrop-blur-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">

          <div className="relative shrink-0">
            {selectedUser.profilePic ? (
              <img
                src={selectedUser.profilePic}
                alt={selectedUser.fullName}
                className="size-11 rounded-full object-cover ring-2 ring-white shadow-sm"
              />
            ) : (
              <div className="size-11 rounded-full bg-gradient-to-br from-[#03488A] to-[#00AAF1] grid place-items-center text-white font-bold text-sm ring-2 ring-white shadow-sm">
                {initialOf(selectedUser.fullName)}
              </div>
            )}
            {isOnline && (
              <span className="absolute bottom-0 right-0 size-3 bg-emerald-400 rounded-full ring-2 ring-white" />
            )}
          </div>

          <div className="leading-tight">
            <h3 className="font-bold text-slate-800 text-sm">
              {selectedUser.fullName}
            </h3>
            <div className="flex items-center gap-1.5 mt-0.5">
              <span
                className={`w-1.5 h-1.5 rounded-full ${
                  isOnline ? "bg-emerald-500 animate-pulse" : "bg-slate-300"
                }`}
              />
              <span className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
                {isOnline ? "Online" : "Offline"}
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-1">
          <button
            className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-[#03488A] transition"
            title="More options"
          >
            <MoreVertical size={16} />
          </button>
          <button
            onClick={() => setSelectedUser(null)}
            className="p-2 rounded-lg text-slate-500 hover:bg-red-50 hover:text-red-500 transition"
            title="Close conversation"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
